import { Input as SemanticInput, InputProps } from 'semantic-ui-react';
import styled from '@emotion/styled';

export interface StyledInputProps extends InputProps {
	isWide: boolean;
}

export const StyledInput = styled(SemanticInput, {
	shouldForwardProp: (prop) => prop !== 'isWide'
})<StyledInputProps>`
	flex: ${(props) => (props.isWide ? '1 1' : 'none')};
`;
